import { useEffect } from 'react';
import { gameInfoScrollService } from '@theme/js/components/common/Game/GameInfoScrollService';

/* eslint-disable no-else-return */
export const useHideContentAndSaveScroll = () => {
    useEffect(() => {
        const scrollableElement = document.scrollingElement || document.documentElement;

        const mainContent = document.querySelector('#main-content') as HTMLElement;

        if (mainContent) {
            mainContent.style.display = 'none';
        }

        return () => {
            if (mainContent) {
                mainContent.style.display = 'block';
            }
            scrollableElement.scrollTop = gameInfoScrollService.savedScroll;
        };
    }, []);
};
